import { normalizeTime } from './timeUtils';
import { LLM_COMBINATIONS } from '../constants/config.js';
import { sanitizeColumnName } from '../utils/parseModelResponse';

export function getRowColor(row, fullyRows) {
  if (!row || !Array.isArray(fullyRows)) {
    return 'white';
  }

  const found = fullyRows.find(r =>
    r.patnr_id === row.patnr_id &&
    normalizeTime(r.created_at) === normalizeTime(row.time)
  );
  if (found) {
    return '#e6f4ea';
  }
  return 'white';
}

export function isRowActive(row, auswertungen) {
  if (!Array.isArray(auswertungen)) return false;

  const matching = auswertungen.find(r => r.patnr_id === row.patnr_id && normalizeTime(r.time) === normalizeTime(row.time));
  if (!matching) return false;

  let total = 0;
  let filled = 0;

  for (const [providerKey, providerModel] of LLM_COMBINATIONS) {
    const column = sanitizeColumnName(providerKey, providerModel);
    const jsonField = `${column}_json`;

    const value = matching[jsonField];
    const isFilled = value && value.trim() !== '';

    total++;
    if (isFilled) {
      filled++;
    }
  }

  if (filled === total) {
    return 'green';  // all raw fields filled → green checkmark
  } else if (filled > 0) {
    return 'orange'; // some raw fields filled → orange checkmark
  } else {
    return null;     // no checkmark
  }
}

export const getCellColor = (state) => {
  if (state === 'ok') return '#e0f7e9';
  if (state === 'bad') return '#fbe9e9';
  return 'inherit';
};

export const getColumnColor = (colIndex, rowLabels, cellStates) => {
  const total = rowLabels.length - 1;
  let green = 0, red = 0;
  for (let i = 0; i < total; i++) {
    const key = `${i}_${colIndex}`;
    if (cellStates[key] === 'ok') green++;
    if (cellStates[key] === 'bad') red++;
  }
  if (green + red !== total) return 'inherit';
  if (green === total) return '#e0f7e9';
  if (red === total) return '#fbe9e9';
  return '#f3e5f5';
};
